export default __webpack_public_path__ + "static/media/icon_info.416e0ec0.svg";